module.exports = __webpack_public_path__ + "img/feiyong.c07c63b7.png";